export interface OldPointThreshold {
	pointsLevelReached: number,
	points: number,
	euros: number
}

export const OLD_POINT_THRESHOLDS: OldPointThreshold[] = [
	{
		pointsLevelReached: 1,
		points: 250,
		euros: 5
	},
	{
		pointsLevelReached: 2,
		points: 500,
		euros: 10
	},
	{
		pointsLevelReached: 3,
		points: 750,
		euros: 15
	}
];

export const getCurrentThreshold = (points: number): OldPointThreshold => {
	const threshold = OLD_POINT_THRESHOLDS.find(threshold => threshold.points > points);
	return threshold ? threshold : OLD_POINT_THRESHOLDS[2];
};

export const getLevelReached = (points: number): number => {
	const threshold = OLD_POINT_THRESHOLDS.filter(threshold => threshold.points <= points).pop();
	return threshold ? threshold.pointsLevelReached : 0;
};

